<template>
  
    <div class="flex flex-row text-black text-xl rounded">

        <div v-if="showTime">

            <div v-if="isBooked">

                <div class="myPitchTimeSlotRedText" v-if="index % 2 == 0">

                    <label>{{time}}</label>
                </div>

                <div class="myPitchTimeSlotLighRedText" v-else>

                    <label>{{time}}</label>
                </div>
            </div>

            <div v-else-if="clicked" >

                <div class="myPitchTimeSlotWhiteText">

                    <label>{{time}}</label>
                </div>
            </div>

            <div v-else >

                <div class="myPitchTimeSlotGreenText" v-if="index % 2 == 0">

                    <label>{{time}}</label>
                </div>

                <div class="myPitchTimeSlotLightGreenText" v-else>

                    <label>{{time}}</label>
                </div>
            </div>
        </div>
        <div v-else>

            <div>

                <div class="myPitchTimeSlotLightGrayText" v-if="index % 2 == 0" >

                    <label>{{time}}</label>
                </div>

                <div class="myPitchTimeSlotLightGrayText" v-else>

                    <label>{{time}}</label>
                </div>
            </div>
        </div>
  </div>

</template>

<script>

import componentsHelpers from '../../classes/componentHelpers';

import moment from 'moment';
export default {

    mounted(){

        // console.log(`time is: ${this.time}`);
        // console.log(`endTime is: ${this.endTime}`);
    },

    props:{
        
        index: 0,

        time: '',

        endTime: '',

        dayDate:'',
        
        mySlot:{

            type: Object
        },

        showTime: true,

        addBookingTime: {

            type: Function
        },

        removeBookingTime: {

            type: Function
        }
    },

    computed:{
        
         isBooked(){

            //  console.log(`inside isBooked, mySlot.two_pitch_bookings.length: ${this.mySlot.two_pitch_bookings.length}`);

            for(let i = 0; i < this.mySlot.two_pitch_bookings.length; i++){

                // console.log(`this.mySlot.two_pitch_bookings[i].day_Date: ${this.mySlot.two_pitch_bookings[i].day_date}`);
                
                // console.log(`this.time ${this.time}`)

                // console.log(`startTime ${this.mySlot.two_pitch_bookings[i].start_time}`)
                // console.log(`endTime ${this.mySlot.two_pitch_bookings[i].end_time}`)

                if(this.mySlot.two_pitch_bookings[i].day_date == this.dayDate){
    
                    // console.log(`this.dayDate: ${this.dayDate}`);
                    // console.log(`this.time: ${this.time}`);

                    // console.log(`start_time: ${this.mySlot.two_pitch_bookings[i].start_time}`);
                    // console.log(`end_time: ${this.mySlot.two_pitch_bookings[i].end_time}`);

                    const formattedTime = moment(this.time, 'hh a').format('HH:mm')
                    // console.log(`this.temp: ${temp}`);

                    const currentTime = moment(new Date(`1970/01/01 ${formattedTime}`));

                    const startTime = moment(new Date(`1970/01/01 ${this.mySlot.two_pitch_bookings[i].start_time}`));

                    // const endTime = moment(new Date(`1970/01/01 ${this.mySlot.two_pitch_bookings[i].end_time}`));
                    
                     let endTime; 
                    
                    if(this.mySlot.two_pitch_bookings[i].end_time == '00:00:00'){

                        endTime = moment(new Date(`1970/01/01 ${this.mySlot.two_pitch_bookings[i].end_time}`)).add('day', 1);

                    }else{

                        endTime = moment(new Date(`1970/01/01 ${this.mySlot.two_pitch_bookings[i].end_time}`));
                    }

                    // const endTime2 = moment(new Date(`1970/01/01 ${this.mySlot.two_pitch_bookings[i].end_time}`)).subtract('hours', 1);

                    // console.log(`endTime: ${endTime}`);
                    // console.log(`endTime2: ${endTime2}`);

                    // console.log(`moment(${currentTime}).isSameOrAfter(${startTime}) && moment(${currentTime}).isSameOrBefore(${endTime})`);

                    // console.log(`result 1: ${moment(currentTime).isSameOrAfter(startTime)}`);
                    // console.log(`result 2: ${moment(currentTime).isSameOrBefore(endTime)}`);


                    // if(moment(currentTime).isSameOrAfter(startTime) && moment(currentTime).isSameOrBefore(endTime)){
                        
                    if(moment(currentTime).isSameOrAfter(startTime) && moment(currentTime).isBefore(endTime)){
                        // console.log(`return true`);
                        return true;
                    }
                }
            }

            return false;
        }
    },

    methods:{

        // notBookable(){

        //     componentsHelpers.toastIt(this.$toasted, this.$t('pitch.notBookable'), 3, 'outline', true)
        // },

        // bookable(){

        //     // console.log(`inside bookable`);

        //     if(this.clicked == false){

        //         this.clicked = true;
        //         this.addBookingTime(this.time, this.mySlot.id, this.clearClicked);
        //     }else{

        //         this.clicked = false;

        //         this.removeBookingTime(this.time, this.mySlot.id);
        //     }
        // },

        clearClicked(){

            this.clicked = false;
        }
    },

    data: function(){

        return{

            clicked: false,
        }
    }

}
</script>

<style>

</style>